"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styles = require("../shared/styles");
var _Icon = require("./Icon");
var _ErrorUnderComponent = require("../molecules/ErrorUnderComponent");
var _jsxRuntime = require("react/jsx-runtime");
var InputWrapper = _styledComponents.default.div.withConfig({
  displayName: "Input__InputWrapper",
  componentId: "sc-9x9vgf-0"
})(["display:flex;align-items:center;gap:", ";box-sizing:border-box;background-color:", ";border:1px solid ", ";padding:0px ", ";border-radius:", ";height:", ";width:100%;&:hover{border:1px solid ", ";}&:focus-within{outline:4px solid ", ";border:1px solid ", ";}&:active{outline:4px solid ", ";border:1px solid ", ";}", ""], _styles.spacing.xs, function (_ref) {
  var error = _ref.error;
  return error ? _styles.colors.background['error'] : _styles.colors.background.primary;
}, function (_ref2) {
  var error = _ref2.error,
    type = _ref2.type;
  return error ? _styles.colors.border['error'].default : _styles.colors.border[type].default;
}, _styles.spacing.s, _styles.borderRadius.s, function (_ref3) {
  var size = _ref3.size;
  return _styles.height[size];
}, function (_ref4) {
  var error = _ref4.error,
    type = _ref4.type;
  return error ? _styles.colors.border['error'].hover : _styles.colors.border[type].hover;
}, _styles.colors.outline.focus, _styles.colors.border.focus, _styles.colors.outline.active, _styles.colors.border.focus, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? (0, _styledComponents.css)(["pointer-events:none;color:", ";background-color:", ";border-color:", ";"], _styles.colors.text.secondary, _styles.colors.background.disabled, _styles.colors.border.disabled) : (0, _styledComponents.css)([""]);
});
var InputWithoutBorders = _styledComponents.default.input.withConfig({
  displayName: "Input__InputWithoutBorders",
  componentId: "sc-9x9vgf-1"
})(["display:flex;align-items:center;border:none;background-image:none;background-color:transparent;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;outline:none;width:100%;color:", ";", ";::placeholder{color:", ";}"], _styles.colors.text.primary, function (_ref6) {
  var size = _ref6.size;
  return _styles.fonts.atom[size];
}, _styles.colors.text.secondary);
var Input = exports.Input = /*#__PURE__*/_react.default.forwardRef(function (_ref7, ref) {
  var type = _ref7.type,
    size = _ref7.size,
    error = _ref7.error,
    icon = _ref7.icon,
    disabled = _ref7.disabled,
    defaultInputProps = _objectWithoutProperties(_ref7, ["type", "size", "error", "icon", "disabled"]);
  var errorContext = (0, _react.useContext)(_ErrorUnderComponent.ErrorContext);
  var inputRef = (0, _react.useRef)(null);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      focus: function focus() {
        inputRef.current.focus();
      },
      setValue: function setValue(value) {
        return inputRef.current.value = value;
      }
    };
  });
  var focusInput = function focusInput() {
    var input = inputRef.current;
    if (input) input.focus();
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(InputWrapper, {
    type: type,
    size: size,
    disabled: disabled,
    error: error,
    onClick: focusInput,
    children: [icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: icon,
      size: _styles.iconSizes.atom[size],
      color: disabled ? 'disabled' : 'primary'
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(InputWithoutBorders, _objectSpread({}, defaultInputProps, {
      size: size,
      ref: inputRef
    })), error && !errorContext && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: 'warning',
      size: _styles.iconSizes.atom[size],
      color: 'error'
    })]
  });
});
Input.defaultProps = {
  type: 'primary',
  size: 'm',
  error: false,
  onChange: function onChange(e) {
    return e.target.value;
  },
  onBlur: function onBlur(e) {
    return e.target.value;
  }
};